// The glance's dark set (glance.css [data-glance-theme="dark"]): the viewer's
// own choice, kept in this browser. The rest of the app stays as it is.
import React, { useEffect, useState } from "react";

const KEY = "bl_glance_theme";
const read = () => { try { return localStorage.getItem(KEY) === "dark" ? "dark" : "light"; } catch (e) { return "light"; } };
const apply = (t) => { try { if (t === "dark") document.documentElement.setAttribute("data-glance-theme", "dark"); else document.documentElement.removeAttribute("data-glance-theme"); } catch (e) { /* no document */ } };

/** Apply the remembered choice on a page that shows glance content. */
export function useGlanceTheme() {
  useEffect(() => { apply(read()); return () => apply("light"); }, []);
}

export default function GlanceThemeToggle() {
  const [theme, setTheme] = useState(read);
  useEffect(() => { apply(theme); try { localStorage.setItem(KEY, theme); } catch (e) { /* private window */ } }, [theme]);
  return (
    <button type="button" className="g-linkbtn g-noprint" aria-pressed={theme === "dark"} onClick={() => setTheme(theme === "dark" ? "light" : "dark")}>
      {theme === "dark" ? "Light" : "Dark"}
    </button>
  );
}
